import { useContext, useEffect, useState } from "react";
import newRequest from "../../../../utils/newRequest";
import DataTable from "../../../../components/userAdminPanel/Components/UserDataTable/DataTable";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { headerDataColumn } from "../../../../datatablesource";
import CustomSnakebar from "../../../../utils/CustomSnakebar";
import AddHeaders from "./AddHeaders";
import UpdateHeader from "./UpdateHeader";

const Adminheader = () => {
    const { t, i18n } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const [isCreatePopupVisible, setCreatePopupVisibility] = useState(false);
    const [brandsData, setBrandsData] = useState([]);
    const handleShowCreatePopup = () => {
        setCreatePopupVisibility(true);
    };

    const [isUpdatePopupVisible, setUpdatePopupVisibility] = useState(false);

    const handleShowUpdatePopup = (row) => {
        setUpdatePopupVisibility(true);
        // save this row data in session storage
        sessionStorage.setItem("updateheadersection", JSON.stringify(row));
    };
    const [filteredData, setFilteredData] = useState([]);

    const refreshcitiesData = async () => {
        try {
            const response = await newRequest.get("/getAllfirst_container");
            const citiesData = response?.data || [];
            setData(response?.data || []);
            setIsLoading(false);
        } catch (err) {
            // console.log(err);
            setIsLoading(false);
        }
    };
    useEffect(() => {
        refreshcitiesData(); // Calling the function within useEffect, not inside itself
    }, []);

    const handleDelete = async (row) => {
        Swal.fire({
            title: `${t("Are you sure to delete this record?")}!`,
            text: `${t("You will not be able to recover this")} ${t("Header")}!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: `${t("Yes")} , ${t("Delete")}!`,
            cancelButtonText: `${t("No, keep it")}!`,
            // changes the color of the confirm button to red
            confirmButtonColor: "#1E3B8B",
            cancelButtonColor: "#FF0032",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const isDeleted = await newRequest.delete(
                        "/deletefirst_container/" + row?.id
                    );
                    if (isDeleted) {
                        setMessage(
                            ` ${t("Header")} ${t("has been not deleted")} ${t(
                                "successfully"
                            )}!`
                        );
                        // filter out the deleted user frm the data
                        const filteredData = brandsData.filter(
                            (item) => item?.id !== row?.id
                        );
                        setBrandsData(filteredData);
                        refreshcitiesData();
                    } else {
                        setError("Failed to delete user");
                    }
                } catch (error) {
                    console.error("Error deleting user:", error);
                    setError(
                        `${t("Header")}${t("has been not deleted")}${t("Delete")}${t(
                            "has been not deleted"
                        )}!`
                    );
                }
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                return;
            }
        });
    };

    const handleRowClickInParent = (item) => {
        if (!item || item?.length === 0) {
            // setTableSelectedRows(data)
            setFilteredData(data);
            return;
        }
    };

    const resetSnakeBarMessages = () => {
        setError(null);
        setMessage(null);
    };

    return (
      <div>
        <div className={`p-0 h-full`}>
          {message && (
            <CustomSnakebar
              message={message}
              severity="success"
              onClose={resetSnakeBarMessages}
            />
          )}
          {error && (
            <CustomSnakebar
              message={error}
              severity="error"
              onClose={resetSnakeBarMessages}
            />
          )}
          <div className="flex justify-center items-center">
            <div className="h-auto w-[97%] px-0 pt-4">
              <div className="h-auto w-full p-0 bg-white shadow-xl rounded-md">
                <div
                  className={`flex  sm:justify-start items-center flex-wrap gap-2 py-7 px-3 ${
                    i18n.language === "ar"
                      ? "flex-row-reverse justify-start"
                      : "flex-row justify-start"
                  }`}
                >
                  <button
                    onClick={handleShowCreatePopup}
                    className="rounded-full bg-secondary font-body px-5 py-1 text-sm mb-3 text-white transition duration-200 hover:bg-primary"
                  >
                    <i className="fas fa-plus mr-2"></i>
                    {t("Add")}
                  </button>
                </div>
                {/* DataGrid */}
                <div style={{ marginLeft: "-11px", marginRight: "-11px" }}>
                  <DataTable
                    data={data}
                    title={`${t("Header")}`}
                    columnsName={headerDataColumn(t)}
                    loading={isLoading}
                    secondaryColor="secondary"
                    handleRowClickInParent={handleRowClickInParent}
                    dropDownOptions={[
                      // {
                      //     label: `${t('View')}`,
                      //     icon: (
                      //         <VisibilityIcon
                      //             fontSize="small"
                      //             color="action"
                      //             style={{ color: "rgb(37 99 235)" }}
                      //         />
                      //     ),
                      //     action: handleView,
                      // },
                      {
                        label: `${t("Edit")}`,
                        icon: (
                          <EditIcon
                            fontSize="small"
                            color="action"
                            style={{ color: "rgb(37 99 235)" }}
                          />
                        ),
                        action: handleShowUpdatePopup,
                      },
                      {
                        label: `${t("Delete")}`,
                        icon: (
                          <DeleteIcon
                            fontSize="small"
                            color="action"
                            style={{ color: "rgb(37 99 235)" }}
                          />
                        ),
                        action: handleDelete,
                      },
                    ]}
                    uniqueId="gtinMainTableId"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Addunit component with handleShowCreatePopup prop */}
          {isCreatePopupVisible && (
            <AddHeaders
              isVisible={isCreatePopupVisible}
              setVisibility={setCreatePopupVisibility}
              refreshBrandData={refreshcitiesData}
            />
          )}
          {/* Updateunit component with handleShowUpdatePopup prop */}
          {isUpdatePopupVisible && (
            <UpdateHeader
              isVisible={isUpdatePopupVisible}
              setVisibility={setUpdatePopupVisibility}
              refreshBrandData={refreshcitiesData}
            />
          )}
        </div>
      </div>
    );
};

export default Adminheader;
